import Counter from "components/Counter/Counter";
import React from "react";
interface CartCounterProps {
  itemId: string;
  itemCount: number;
  updateItem: (id: string, count: number) => void;
}

const CartCounter: React.FC<CartCounterProps> = ({ itemId, itemCount, updateItem }) => {
  const increase = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    let newCount = itemCount + 1;
    updateItem(itemId, newCount);
  };

  const decrease = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    if (itemCount - 1 > 0) {
      let newCount = itemCount - 1;
      updateItem(itemId, newCount);
    }
  };

  return <Counter itemCount={itemCount} increase={increase} decrease={decrease} />;
};

export default CartCounter;
